import React from "react";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const AnimatedCounter = ({ end, duration = 2000, label }) => {
  const [count, setCount] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    let start = 0;
    const stepTime = Math.abs(Math.floor(duration / end));
    const interval = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= end) clearInterval(interval);
    }, stepTime);
    return () => clearInterval(interval);
  }, [end, duration]);

  return (
    <Box textAlign="center">
      <Box
        sx={{
          width: 100,
          height: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '24px auto 12px',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            animation: 'bounce 0.3s ease',
            color: theme.palette.counters.secondary,
            '@keyframes bounce': {
              '0%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.2)' },
              '100%': { transform: 'scale(1)' },
            },
          }}
        >
          {count}
        </Typography>
      </Box>
      <Typography variant="body1" color="#FFFF">{label}</Typography>
    </Box>
  );
};

// PropTypes validation
AnimatedCounter.propTypes = {
  end: PropTypes.number.isRequired,
  duration: PropTypes.number,
  label: PropTypes.string,
};

export default AnimatedCounter;
